import React, { useContext } from "react";
import "../sass/global/footer.scss";
import { ThemeContext } from "../context/themeContext"; // Importando o contexto de tema
import LogoDark from "../assets/logo-ss-escuro.webp";  // Logo para o tema escuro
import LogoLight from "../assets/logo-ss-claro.webp"; // Logo para o tema claro

const Footer = () => {
  const { theme } = useContext(ThemeContext); // Obtém o tema atual

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* LOGO E SLOGAN */}
        <div className="footer-brand">
          <img 
            src={theme === "dark" ? LogoDark : LogoLight} 
            alt="Santsystem" 
            className="footer-logo" 
          />
        </div>

     
      </div>

      {/* COPYRIGHT */}
      <div className="footer-bottom">
        <p>&copy; 2026 Santsystem. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
